import { Component } from '@angular/core';
import { NavController,AlertController,MenuController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { ViewordinePage } from "../../pages/viewordine/viewordine";
import { RicercaordinazionePage } from "../../pages/ricercaordinazione/ricercaordinazione";
import {AuthProvider} from "../../providers/auth/auth";

/**
 * Generated class for the ProdottiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ordinazioni',
  templateUrl: 'ordinazioni.html',
})
export class OrdinazioniPage {
  ordini: any;
  errorMessage: string;
  public numResult;
  stato;
  info;

  constructor(public navCtrl: NavController, public rest: RestApiProvider,
    private readonly authProvider: AuthProvider,
    private alertCtrl: AlertController,
    private menu: MenuController,

    ) {
    this.getOrdineTodayList();
  }
  chiudi(){
    let alert = this.alertCtrl.create({
      title: "Chiusura",
      message: "Sei sicuro di volor chiudere il negozio?",
      enableBackdropDismiss: false, // <- Here! :)

      buttons: [
      
        {
          text: 'Annulla',
          role: 'cancel',

        },
        {
          text: 'Conferma',
          handler: () => {
            this.info.aperto=false;
            this.rest.updateApertura(this.info);
            //this.navCtrl.push(ImpostazionePage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });;
            let hideFooterTimeout1 = setTimeout(() => {
              this.infoStoreToday();
            }, 2000);
           // this.navCtrl.setRoot(ImpostazionePage);
          }
        }
      ],
    });
    alert.present();

  }
  apri(){
    let alert = this.alertCtrl.create({
      title: "Chiusura",
      message: "Sei sicuro di volor aprire il negozio?",
      enableBackdropDismiss: false, // <- Here! :)

      buttons: [
      
        {
          text: 'Annulla',
          role: 'cancel',

        },
        {
          text: 'Conferma',
          handler: () => {
            this.info.aperto=true;
            this.rest.updateApertura(this.info);
           // this.navCtrl.push(ImpostazionePage).then(() => { this.navCtrl.remove(this.navCtrl.getActive().index - 2, 2); });;
           let hideFooterTimeout1 = setTimeout(() => {
            this.infoStoreToday();
          }, 2000);
           //this.navCtrl.setRoot(ImpostazionePage);
          }
        }
      ]
    });
    alert.present();
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad OrdinazioniPage');
    this.menu.swipeEnable(false);

  }
  ionViewWillEnter() {
    console.log('ionViewWillEnter CapconsegnaPage');
    this.getOrdineTodayList();
    this.infoStoreToday();
    this.getInfoRistorante();
  }
  refreshPage() {
    this.ionViewWillEnter();
  }

  openOrdinePage(ordine) {

    this.navCtrl.push(ViewordinePage, { ordine: ordine });


  }
  getInfoRistorante() {
    this.rest.getInfoRistorante()
      .subscribe(
        info => this.info = info,
        error => this.errorMessage = <any>error);

    console.log("infoRistorante:" + JSON.stringify(this.info));
  }
  getOrdineTodayList() {
    console.log('getOrdineTodayList ');

    this.rest.getOrdineTodayList().subscribe(
      ordini => this.ordini = ordini,
      error => this.errorMessage = <any>error);
   
  }
  infoStoreToday() {

    this.rest.infoStoreToday().subscribe(
      stato => this.stato = stato,
      error => this.errorMessage = <any>error);
  }
  search(){
    this.navCtrl.push(RicercaordinazionePage);

  }
  logout(){
    this.authProvider.logout();

  }
  
}



// WEBPACK FOOTER //
// ./src/pages/ordinazioni/ordinazioni.ts